module.exports = __webpack_public_path__ + "img/nthu-logo.8a87640c.png";